import React from "react";
import PropTypes from "prop-types";
import "./css/microphoneButton.css";

const MicrophoneButton = ({ isRecording, startStopSpeechRecognition }) => {
  const classList = ["btn--icon-only", "btn btn--clear", "btn--microphone"];
  if (isRecording) classList.push("btn--microphone--active");
  return (
    <button
      data-quid="microphone-button"
      aria-label="begin speech recognition"
      className={classList.join(" ")}
      onClick={startStopSpeechRecognition}
    />
  );
};

MicrophoneButton.propTypes = {
  isRecording: PropTypes.bool.isRequired,
  startStopSpeechRecognition: PropTypes.func.isRequired
};

export default MicrophoneButton;
